import { useState, useEffect } from 'react'
import MenuBar from './menu/MenuBar';
import * as XLSX from 'xlsx'
import { InboxOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, message, Upload, Modal, notification } from 'antd';
import { useSelector, useDispatch } from "react-redux";
import { delUser, setUser } from '../app/features/user/userSlice';
import { getNamalData, postData } from '../data/allfunction';
import { useHistory } from 'react-router-dom';

import MakeDocLong from './pdf/MakeDocLong';
import MakeDocSafty from './pdf/MakeDocSafty';
import { gotoMakePDF } from './account/gotoPDF';
const SellFromExcell = () => {
  const history = useHistory()
  const dispatch = useDispatch()

  const [package_id, setpackage_id] = useState(null)
  const [data_package, setdata_package] = useState([])
  const [data, setData] = useState([])
  const [oneData, setOnedata] = useState({})
  const [open, setOpen] = useState(false);
  const [nameFile, setNameFile] = useState('ກະລຸນາເລືອກໄຟຣ...');
  const [modalsave, setmodalsave] = useState(false)
  const [loadingPDF, setloadingPDF] = useState(false)
  const [modalShowPolicy, setmodalShowPolicy] = useState(false)
  const [sent_startCover, setsent_startCover] = useState()
  const [sent_endCover, setsent_endCover] = useState()
  const [datasentPDF, setdatasentPDF] = useState(0)
  const [no, setno] = useState(0)
  const [drivercover_option, setdrivercover_option] = useState([])
  const [thirdcover_option, setthirdcover_option] = useState([])
  const { token, retoken, user, user_id } = useSelector(state => {
    return state.user
  })
  const ip = process.env.REACT_APP_IP


  const readUploadFile = (e) => {
    console.log(e)
    try {
      e.preventDefault();
      if (e.target.files) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const json = XLSX.utils.sheet_to_json(worksheet);
          setData(json);
        };
        reader.readAsArrayBuffer(e.target.files[0]);
      }
    } catch (error) {

    }
  }

  const openModal = async (e) => {

    setOpen(true)
    setOnedata(e)

  }
  function saveToDAtabase() {
    createPolicy()
    let d = data
    const arr = d.filter((item) => item.no !== oneData.no);
    setData(arr);
    setOpen(false)


    const dataSetForGet =
    {
      o_name: 'o_name',
      o_address: `${'villageSelect'} ເມືອງ ${'distSelect'} ແຂວງ ${'proviceSelect'}`,
      o_tel: 'o_tel',
      o_type: 'o_type',
      o_make: 'o_make',
      o_plate: 'o_plate',
      o_color: 'o_color',
      o_power: 'o_power',
      o_engine: 'o_engine',
      o_chassis: 'o_chassis',
      o_weight: 'o_weight',
      o_seats: 'o_seats',
      a_used: 'a_used',
      a_type: 'a_type',
      premuim: 'premuim',
      vat: 'vat',
      register: 'register',
      total_premuim: 'total_premuim',
      start: 'sent_startCover',
      end: 'sent_endCover',
      cover: 'cover',
      user_add: user_id,
      dateadd: Date.now(),
      emp_paid: 'emp_paid',
      package_id
    }
    console.log(dataSetForGet)
  }


  function change(e) {

    try {
      e.preventDefault();
      if (e.target.files) {
        setNameFile(e.target.files[0].name)
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const json = XLSX.utils.sheet_to_json(worksheet);
          setData(json);
        };
        reader.readAsArrayBuffer(e.target.files[0]);
      }
    } catch (error) {

    }
  }
  function createPolicy() {
    // setmodalsave(false)
    let link = `${ip}sell_online/long`
    const dataSetForGet =
    {
      // o_name: o_name,
      // o_address: o_address,
      // o_address: `${villageSelect} ເມືອງ ${distSelect} ແຂວງ ${proviceSelect}`,
      // o_tel: o_tel,
      // o_type: o_type,
      // o_make: o_make,
      // o_plate: o_plate,
      // o_color: o_color,
      // o_power: o_power,
      // o_engine: o_engine,
      // o_chassis: o_chassis,
      // o_weight: o_weight,
      // o_seats: o_seats,
      // a_used: a_used,
      // a_type: a_type,
      // c_insured: c_insured,
      // c_curren: c_curren,
      // c_tex: c_tex,
      // a_premuim: a_premuim,
      // a_discount: a_discount,
      // a_net_premuim: a_net_premuim,
      // h: h,
      // i: i,
      // c_premuim: c_premuim,
      // c_discount: c_discount,
      // c_net_premuim: c_net_premuim,
      // premuim: premuim,
      // vat: vat,
      // register: register,
      // total_premuim: total_premuim,
      // start: sent_startCover,
      // end: sent_endCover,
      // cover: cover,
      // user_add: user_id,
      // dateadd: Date.now(),
      // emp_paid: emp_paid
    }

    function setWhenUpdate(result) {
      if (result.data.fieldCount === 0) {
        setmodalsave(false)
        notification['success']({
          message: 'ແຈ້ງເຕືອນ',
          description: 'ບັນທຶກຂໍ້ມູນສຳເຫຼັດ'
        });
        setTimeout(() => {
          // const win = window.open(`${l}/DocLong/${result.data.insertId}`, "_blank");
          // win.focus();               
          getOneData(result.data.insertId)
        }, 500);
      } else {
        setmodalsave(false)
        alert(JSON.stringify(result))
      }
    }

    if (sent_startCover === undefined || sent_endCover === undefined) {
      setmodalsave(false)
      //ທົດສອບການເຮັດວຽກ
      getOneData(35)
      notification['error']({
        message: 'ແຈ້ງເຕືອນ',
        description: 'ກະລຸນາກວດສອບວັນທີການຄຸ້ມກັນ'
      });
    } else {

      // postData(message, link, dataSetForGet, token, retoken, user, dispatch, delUser, setUser, history, setWhenUpdate)
    }

  }
  function getOneData(policy_no) {
    setloadingPDF(true)
    let link = `${ip}sell_online/getOne`
    let dataSetForGet = {
      no: policy_no,
      user: user_id
    }
    function setWhenUpdate(result) {
      if (result.data.status === 200) {
        setdatasentPDF(result.data.rows[0])
        setno(policy_no)
        setTimeout(() => {
          setmodalShowPolicy(true)
          // message.success(`ພົບເລກທີສັນຍາ ${policy_no} ໃນລະບົບ`);
        }, 1000);
      } else {
        setloadingPDF(false)
        message.success(`ບໍ່ພົບເລກທີສັນຍາ ${policy_no} ໃນລະບົບ`);
      }
    }
    postData(message, link, dataSetForGet, token, retoken, user, dispatch, delUser, setUser, history, setWhenUpdate)
  }


  //ດິງຂໍ້ມູນປະເພດ ອ້ອບຊັ່ນຜູ້ຂັບຂີ່
  useEffect(() => {
    var requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(ip + "sell_online/drivercover_option", requestOptions)
      .then(response => response.json())
      .then(result => {
        setdrivercover_option(result.data.data)
      })
      .catch(error => console.log('error', error));
  }, [])
  //ດິງຂໍ້ມູນປະເພດ ອ້ອບຊັ່ນບຸກຄຸນທີສາມ
  useEffect(() => {
    var requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(ip + "sell_online/thirdcover_option", requestOptions)
      .then(response => response.json())
      .then(result => {
        setthirdcover_option(result.data.data)
      })
      .catch(error => console.log('error', error));

    packages()
  }, [])

  function packages() {
    var requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(ip + "sell_online/packages", requestOptions)
      .then(response => response.json())
      .then(result => {

        if (result.data.status === 200) {
          setdata_package(result.data.data)
        } else {
          setdata_package([])
        }

      })
      .catch(error => console.log('error', error));
  }
  return (
    <>
      <div>
      SellFromExcell_2
        {/* <Modal
          title="Modal 1000px width"
          centered
          visible={open}
          onOk={() => saveToDAtabase()}
          onCancel={() => setOpen(false)}
        // width={1000}
        >
          {JSON.stringify(oneData)}
        </Modal> */}


        <Modal
          title="ກວດຂໍ້ມູນໃຫ້ລະອຽດກ່ອນການບັນທືກ"
          visible={open}
          closable={false}
          footer={[
            <Button key="ກັບຄືນ" onClick={() => setOpen(false)}>
              ກັບຄືນ
            </Button>,
            <Button key="ຕົກລົງ" onClick={() => saveToDAtabase()}>
              ຕົກລົງ
            </Button>

          ]}
        >
          <div className='B'>
            <div className='B1'> ຜູ້ໃດ້ຮັບການປະກັນໄພ </div>
            <div className='B2'>{oneData.o_name}</div>
          </div>
          <div className='B'>
            <div className='B1'> ເລກທະບຽນ </div>
            <div className='B2'>{
              // o_plate
            }</div>
          </div>
          <div className='B'>
            <div className='B1'> ເລກຈັກ </div>
            <div className='B2'>{
              // o_engine
            }</div>
          </div>
          <div className='B'>
            <div className='B1'> ເລກຖັງ </div>
            <div className='B2'>{
              // o_chassis
            }</div>
          </div>
          <div className='B'>
            <div className='B1'> ການຄຸ້ມກັນ </div>
            <div className='B2'>{
              // cover

            }</div>
          </div>
          <div className="form-group">
            <select className="form-control"
              onChange={(e) => {
                setpackage_id(e.target.value)
              }}
            >
              <option value={null} >ບຸກຄົນທີສາມ</option>
              {
                data_package.map((e, k) => {
                  return (
                    <option key={k} value={e.id} >{e.name}</option>
                  )
                })
              }
            </select>

          </div>
          <div className='B'>
            <div className='B1'> ວັນທີເລີ່ມຄຸ້ມກັນ </div>
            <div className='B2'>{
              // sent_startCover
            }</div>
          </div>
          <div className='B'>
            <div className='B1'> ວັນທີສຶ້ນສຸດຄຸ້ມກັນ </div>
            <div className='B2'>{
              // sent_endCover
            }</div>
          </div>
          <div className='B'>
            <div className='B1'> ລວມມູນຄ່າຕ້ອງຈ່າຍ </div>
            <div className='B2'>{
              // format(total_premuim)
            }</div>
          </div>
          <div className='B'>
            <div className='B1'> ສະຖານະການຈ່າຍເງິນ </div>
            <div className='B2'> {
              // emp_paid === 1 ?
              //  'ຊຳລະສົມບູນ' 
              //  :
              'ລໍຖ້າການຊຳລະ'
            } </div>
          </div>






        </Modal>




        <Modal
          width={'720px'}
          title="ລາຍລະອຽດຂອງສັນຍາການຂາຍ"
          visible={modalShowPolicy}
          closable={false}
          // onOk={() => setmodalShowPolicy(false)}
          // onCancel={() => setmodalShowPolicy(false)}
          footer={[
            <Button key="ກັບຄືນ" onClick={() => {
              setloadingPDF(false)
              setmodalShowPolicy(false)
            }}>
              ປິດ
            </Button>,

          ]}
        >

          {/* <MakeDocLongFirst
            no={no}
            user={user}
            oneData={datasentPDF}
            thirdcover_option={thirdcover_option}
            drivercover_option={drivercover_option}
          /> */}


          {
            gotoMakePDF(datasentPDF.cover) === "L" ?
              <MakeDocLong
                no={datasentPDF.no}
                user={user}
                oneData={datasentPDF}
                thirdcover_option={thirdcover_option}
                drivercover_option={drivercover_option}
              />
              :
              gotoMakePDF(datasentPDF.cover) === "S" ?
                <MakeDocSafty
                  no={datasentPDF.no}
                  oneData={datasentPDF}
                />
                :
                <>
                  {gotoMakePDF(datasentPDF.cover)}
                </>



          }




        </Modal>

      </div>

      <MenuBar />

      <div className="container-fluid">
        <h3 className='mt-3'>
          ການຂາຍປະກັນໄພແບບເປັນຊຸດຈາກເອກະສານ ແອັກແຊວ
        </h3>
        <form>
          {/* <p>Custom file:</p> */}
          <div className="custom-file mb-3">
            <input
              type="file"
              className="custom-file-input"
              //  id="customFile" 
              //  name="filename"
              onChange={change} />
            <label className="custom-file-label" for="customFile">{nameFile}</label>
          </div>
        </form>

      </div>

      <div className="container-fluid">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>No</th>
              <th>Firstname</th>
              <th>Lastname</th>
              <th>Email</th>
              <th>Email</th>
            </tr>
          </thead>
          <tbody>


            {
              data.map((e, k) => {
                return (
                  <tr key={k}>
                    <td>{k + 1}</td>
                    <th>{e.no}</th>
                    <td>{e.o_name}</td>
                    <td>{e.o_address}</td>

                    <td>

                      <Button type="primary"
                        onClick={() => openModal(e)}>
                        Open Modal of
                      </Button>

                    </td>
                  </tr>

                )
              })
            }

          </tbody>
        </table>
      </div>


    </>

  );
}

export default SellFromExcell;




